<script lang="ts">
export default {
    name: "ComparePop",
};
</script>

<script setup lang="ts">
import { onMounted } from "vue"
import { contrastFileInfo, addFlightLogEvent, eventForm,imageQuestion } from "@/api/analysisApi"
import { store } from '@/store'

const props = defineProps({
    wayPointVisible: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    wayPointObj: {
        type: Object,
        default: () => {
            return {};
        },
    },
    wayLineObj: {
        type: Object,
        default: () => {
            return {};
        },
    },
});

const emits = defineEmits(["update:wayPointVisible"]);

const rules = reactive({
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    eventType: [{ required: true, message: "请输入事件类型", trigger: "blur" }],
    description: [{ required: true, message: "请输入事件描述", trigger: "blur" }],
});

const pictureList = ref()
const times = ref()
const spanIndex: any = ref([])
const indexList: any = ref([])
const shadowActive = ref(false)
const startTime = ref()
const endTime = ref()
const compareBtn = (item: any, index: any) => {
    var arrIndex = spanIndex.value.indexOf(index);
    if (arrIndex > -1) {
        spanIndex.value.splice(arrIndex, 1);
        indexList.value.splice(arrIndex, 1);
    } else {
        spanIndex.value.push(index);
        indexList.value.push(item);
    }
    if (indexList.value.length == 2) {
        shadowActive.value = true
    } else if (indexList.value.length > 2) {
        spanIndex.value.splice(0, 1);
        indexList.value.splice(0, 1);
    }
}

const loadContrastPictures = () => {
    if (!props.wayPointVisible) return
    if (!props.wayLineObj?.wayline_id) return
    const lng = props.wayPointObj?.longitude_point
    const lat = props.wayPointObj?.latitude_point
    if (lng == null || lat == null) return
    if (times.value) {
        startTime.value = times.value[0] + " " + "00:00:00"
        endTime.value = times.value[1] + " " + "23:59:59"
    }
    contrastFileInfo({
        wayline_id: props.wayLineObj.wayline_id,
        longitude: lng,
        latitude: lat,
        startTime: startTime.value,
        endTime: endTime.value,
        subFileType: "1,2,3",
        pointId:props.wayPointObj?.id
    }).then((res: any) => {
        pictureList.value = res.list
    })
}

/** 弹窗打开或切换航点/航线时重新拉取照片列表 */
watch(
    () =>
        [
            props.wayPointVisible,
            props.wayLineObj?.wayline_id,
            props.wayPointObj?.longitude_point,
            props.wayPointObj?.latitude_point,
        ] as const,
    () => {
        loadContrastPictures()
    },
    { deep: true }
)

function formatTimestamp(timestamp: any) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString(); // 根据本地时间格式显示
}

function dateList() {
    let date = new Date();
    let frontDate = new Date()
    let year = date.getFullYear();
    frontDate.setDate(frontDate.getDate() - 7)//前7天减7，前N天减N
    let dateArr1: any = [frontDate.getMonth() + 1, frontDate.getDate()];
    let dateArr2: any = [date.getMonth() + 1, date.getDate()];
    //开始格式是M,经过以下循环变为MM
    for (let i = 0; i < dateArr1.length; i++) {
        if (dateArr1[i] >= 1 && dateArr1[i] <= 9) {
            dateArr1[i] = "0" + dateArr1[i];
        }
    }
    for (let i = 0; i < dateArr2.length; i++) {
        if (dateArr2[i] >= 1 && dateArr2[i] <= 9) {
            dateArr2[i] = "0" + dateArr2[i];
        }
    }
    let strDate1 = year + "-" + dateArr1[0] + "-" + dateArr1[1]
    let strDate2 = year + "-" + dateArr2[0] + "-" + dateArr2[1]
    times.value = [strDate1, strDate2]  //[2023-08-31,2023-09-07]
}

const queryChange = () =>{
    loadContrastPictures()
}

const shadowBtn = () => {
    shadowActive.value = false
    spanIndex.value = [];
    indexList.value = [];
    formData.name = undefined
    formData.eventType = undefined
    formData.description = undefined
}

const closeWaypointPhoto = () => {
    shadowBtn()
    emits("update:wayPointVisible", false)
}

const analysisBtn = () =>{
    formData.name = indexList.value[0].longitude + "," + indexList.value[0].latitude + ""
    const list = indexList.value.map((result: any) => {
        return result.objectKey
    })
    console.log(list)
    imageQuestion({
        imageUrls: list,
        question: "帮我对比这两张图片，并生成事件类型（简短）以及事件描述（不超过二百字）"
    }).then((res: any) => {
        const match = res.content.match(/\*\*事件类型：\*\*\s*(.+)/);
        formData.eventType = match ? match[1].trim() : null;
        formData.description = res.content.match(/\*\*事件描述：\*\*\s*([\s\S]*)/)?.[1];
    })
}

const imageRef0: any = ref(null)
const originalWidth = ref(0);
const originalHeight = ref(0);
const imageWidth = ref(0)
const imageHeight = ref(0)
const rect: any = ref(0)
const canvas0: any = ref(null);
let ctx: any = null;
let drawing = false;
let startX = 0;
let startY = 0;
let currentX = 0;
let currentY = 0;

const canvas1: any = ref(null);
let ctx2: any = null;

const markBtn = () => {
    console.log(imageRef0.value)
    originalWidth.value = imageRef0.value.naturalWidth;
    originalHeight.value = imageRef0.value.naturalHeight;
    console.log(originalWidth.value, originalHeight.value)
    const rect = imageRef0.value.getBoundingClientRect();
    imageWidth.value = rect.width;//修改后的尺寸
    imageHeight.value = rect.height;//修改后的尺寸
    console.log(imageWidth.value, imageHeight.value)

    //初始化canvans
    ctx = canvas0.value.getContext('2d');
    canvas0.value.width = canvas0.value.getBoundingClientRect().width
    canvas0.value.height = canvas0.value.getBoundingClientRect().height
    console.log(canvas0.value, canvas0.value.getBoundingClientRect())

    ctx2 = canvas1.value.getContext('2d');
    canvas1.value.width = canvas1.value.getBoundingClientRect().width
    canvas1.value.height = canvas1.value.getBoundingClientRect().height
}

function startDrawing(e: any) {
    const pos = getCanvasRelativePosition(canvas0.value, e);
    startX = pos.x;
    startY = pos.y;
    drawing = true;
}

function getCanvasRelativePosition(canvans: any, event: any) {
    const rect = canvans.getBoundingClientRect();
    return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
    };
}

function draw(e: any) {
    // console.log(e)
    if (!drawing) return;
    currentX = e.offsetX;
    currentY = e.offsetY;
    ctx.clearRect(0, 0, canvas0.value.width, canvas0.value.height); // 清除之前的绘制内容，重新绘制图片和框选区域
    ctx.strokeStyle = "#FF0000"; // 框选框颜色
    ctx.lineWidth = 1; // 框选框宽度
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(currentX, startY);
    ctx.lineTo(currentX, currentY);
    ctx.lineTo(startX, currentY);
    ctx.closePath();
    ctx.stroke(); // 绘制框选框
}
const frameBox = reactive([{
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    className: ""
}])
function stopDrawing() {
    drawing = false;
    const width = Math.abs(currentX - startX);
    const height = Math.abs(currentY - startY);
    const x = Math.min(startX, currentX);
    const y = Math.min(startY, currentY);
    console.log(`框选的坐标：x=${x}, y=${y}, width=${width}, height=${height}`); // 输出框选坐标和尺寸信息
    frameBox[0].x = parseFloat((x / imageWidth.value).toFixed(6))
    frameBox[0].y = parseFloat((y / imageHeight.value).toFixed(6))
    frameBox[0].width = parseFloat((width / imageWidth.value).toFixed(6))
    frameBox[0].height = parseFloat((height / imageHeight.value).toFixed(6))
    if (ctx2) {
        ctx2.clearRect(0, 0, canvas1.value.width, canvas1.value.height); // 清除之前的绘制内容，重新绘制图片和框选区域
        ctx2.strokeStyle = "#FF0000"; // 框选框颜色
        ctx2.lineWidth = 1; // 框选框宽度
        ctx2.strokeRect(x, y, width, height)
    }
}

const dialogVisible = ref(false)
const formData = reactive<eventForm>({})

const confirmBtn = () => {
    if (frameBox[0].x) {
        //wayLineObj航线数据 wayPointObj航点数据
        dialogVisible.value = true
        formData.orgId = props.wayLineObj.org_id
        formData.gatewaySn = props.wayLineObj.device_sn
        formData.aircraftSn = store.informationListStore.informationStore().uavObj.childSn
        formData.jobId = pictureList.value[0].jobId
        formData.lng = props.wayPointObj.longitude_point
        formData.lat = props.wayPointObj.latitude_point
        formData.eventTime = pictureList.value[0].createTime
        formData.eventImages = indexList.value[0].objectKey
        formData.box = frameBox
    } else {
        ElMessage.warning("请先对比图片")
    }
}

const handleSubmit = () => {
    if (frameBox[0].x) {
        //wayLineObj航线数据 wayPointObj航点数据
        dialogVisible.value = true
        formData.orgId = props.wayLineObj.org_id
        formData.gatewaySn = props.wayLineObj.device_sn
        formData.aircraftSn = store.informationListStore.informationStore().uavObj.childSn
        formData.jobId = pictureList.value[0].jobId
        formData.lng = props.wayPointObj.longitude_point
        formData.lat = props.wayPointObj.latitude_point
        formData.eventTime = pictureList.value[0].createTime
        formData.eventImages = indexList.value[0].objectKey
        formData.box = frameBox
        addFlightLogEvent(formData).then((res: any) => {
            ElMessage.success("新增成功")
            dialogVisible.value = false
            shadowBtn()
            emits("update:wayPointVisible", false);
        })
    }else {
        ElMessage.warning("请先对比图片")
    }
}

const closeDialog = () => {
    shadowActive.value = false
    spanIndex.value = [];
    indexList.value = [];
    formData.name = undefined
    formData.eventType = undefined
    formData.description = undefined
}

onMounted(() => {
    dateList()
});
</script>


<template>
    <div class="comparePop" v-if="props.wayPointVisible">
        <div class="waypoint-box">
            <div class="waypoint-header">
                <span class="waypoint-title">航点照片</span>
                <span class="waypoint-close" title="关闭" @click="closeWaypointPhoto">×</span>
            </div>
            <el-date-picker v-model="times" type="daterange" range-separator="至" value-format="YYYY-MM-DD"
                start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="queryChange"/>
            <div class="picture-list">
                <div class="list-word" v-for="(item, index) in pictureList" :key="index">
                    <p>
                        <img :src="item.url" alt="">
                        <span @click="compareBtn(item, index)"
                            :class="{ active: spanIndex.indexOf(index) > -1 }"></span>
                    </p>
                    <p>{{ formatTimestamp(item.createTime) }}</p>
                </div>
            </div>
        </div>
        <div class="shadow-box" v-if="shadowActive">
            <div class="shadow" @click="shadowBtn"></div>
            <div class="title-box">
                <p>航图对比</p>
            </div>
            <div class="analysisBtn" @click.stop="analysisBtn">AI事件分析</div>
            <div class="markBtn" @click.stop="markBtn">图片标记</div>
            <div class="pic-box">
                <div class="pic-word">
                    <div style="position: relative;margin-bottom: 1.6vh;">
                        <img ref="imageRef0" class="markImg" :src="indexList[0].url" alt=""></img>
                        <canvas ref="canvas0" class="imgCanvas" @mousedown="startDrawing" @mousemove="draw"
                            @mouseup="stopDrawing" @mouseleave="stopDrawing"></canvas>
                    </div>
                    <p>拍摄时间：{{ formatTimestamp(indexList[0].createTime) }}</p>
                    <p>拍摄航线：{{ wayLineObj.name }}</p>
                </div>
                <div class="pic-word">
                    <div style="position: relative;margin-bottom: 1.6vh;">
                        <img ref="imageRef1" class="markImg" :src="indexList[1].url" alt=""></img>
                        <canvas ref="canvas1" class="imgCanvas"></canvas>
                    </div>
                    <p>拍摄时间：{{ formatTimestamp(indexList[1].createTime) }}</p>
                    <p>拍摄航线：{{ wayLineObj.name }}</p>
                </div>
            </div>
            <el-form label-width="auto" class="searchForm" :rules="rules" :model="formData">
                <div style="display: flex;">
                    <el-form-item label="事件地点：" class="searchItem" prop="name">
                        <el-input v-model="formData.name" placeholder="请输入预警地点" clearable />
                    </el-form-item>
                    <el-form-item label="事件类型：" class="searchItem" prop="eventType">
                        <el-input v-model="formData.eventType" placeholder="请输入事件类型" clearable />
                    </el-form-item>
                </div>
                <el-form-item label="事件描述：" class="searchItem" prop="description">
                    <el-input type="textarea" v-model="formData.description" placeholder="请输入事件描述"
                        style="min-height: 100px;height: 100px;" class="textarea-box" />
                </el-form-item>
            </el-form>
            <!-- <div class="subBtn" @click="confirmBtn">确认事件</div> -->
            <div class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </div>
        </div>

        <!-- <el-dialog class="compare-dialogBox" destroy-on-close v-model="dialogVisible" title="确认事件："
            @close="closeDialog">
            <el-form label-width="auto" class="searchForm">
                <el-form-item label="事件地点：" class="searchItem">
                    <el-input v-model="formData.name" placeholder="请输入预警地点" clearable />
                </el-form-item>
                <el-form-item label="事件类型：" class="searchItem">
                    <el-input v-model="formData.eventType" placeholder="请输入事件类型" clearable />
                </el-form-item>
                <el-form-item label="事件描述：" class="searchItem">
                    <el-input v-model="formData.description" placeholder="请输入事件描述" clearable />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="handleSubmit">确 定</el-button>
                    <el-button @click="closeDialog">取 消</el-button>
                </div>
            </template>
        </el-dialog> -->
    </div>
</template>

<style lang="scss" scoped>
.comparePop {
    .waypoint-box {
        width: 235px;
        height: 613px;
        border-radius: 8px;
        opacity: 1;
        background: rgba(1, 33, 50, 0.85);
        position: absolute;
        top: 18%;
        left: 67%;
        z-index: 99;

        .waypoint-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 12px 12px 19px;
        }

        .waypoint-title {
            font-family: YouSheBiaoTiHei;
            font-size: 18px;
            font-weight: normal;
            color: #ffffff;
            margin: 0;
        }

        .waypoint-close {
            flex-shrink: 0;
            width: 28px;
            height: 28px;
            line-height: 26px;
            text-align: center;
            cursor: pointer;
            color: #0be8f6;
            font-size: 22px;
            user-select: none;
            border-radius: 4px;
            transition: color 0.2s, background 0.2s;

            &:hover {
                color: #ff6b6b;
                background: rgba(255, 255, 255, 0.08);
            }
        }

        :deep(.el-range-editor--small.el-input__wrapper) {
            width: 200px;
            background: #000619;
            margin-left: 8px;

            .el-range-separator {
                color: #0BE8F6;
            }
        }

        .picture-list {
            width: 210px;
            height: 500px;
            overflow-y: auto;
            // background-color: #0BE8F6;
            margin: 0 auto;
            margin-top: 16px;

            .list-word {
                margin-bottom: 10px;

                p:nth-child(1) {
                    width: 200px;
                    height: 105px;
                    border-radius: 3px;
                    margin-top: 11px;
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                    span {
                        display: inline-block;
                        position: absolute;
                        top: 4px;
                        right: 7px;
                        width: 11px;
                        height: 11px;
                        background: #D8D8D8;
                        border: 1px solid #000000;
                        border-radius: 50%;
                        cursor: pointer;
                    }

                    .active {
                        background: #FF0000;
                    }
                }

                p:nth-child(2) {
                    font-family: Alibaba PuHuiTi 2.0;
                    font-size: 12px;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-top: 4px;
                }
            }
        }
    }

    .shadow-box {
        width: 100vw;
        height: 100vh;
        z-index: 999;
        position: absolute;
        top: 0;
        right: 0;

        .shadow {
            width: 100vw;
            height: 100vh;
            position: absolute;
            top: 0;
            right: 0;
            background: rgba(1, 33, 50, 0.85);
            z-index: -1;
        }

        .title-box {
            width: 19.5vw;
            height: 2.5vh;
            background: url("@/assets/icons/title-bg.png") center no-repeat;
            background-size: cover;
            display: flex;
            margin-left: .7vw;
            margin-top: 50px;
            margin-left: 26px;

            p:nth-child(1) {
                font-family: YouSheBiaoTiHei;
                font-size: 1.125rem;
                font-weight: normal;
                color: #fff;
                margin: 0 0 0 1.5vw;
                line-height: 2.1vh;
            }
        }
        .analysisBtn{
            width: 5.5vw;
            height: 2.6vh;
            border-radius: 3px;
            background: linear-gradient(180deg, #2AC6FF 0%, #127FFF 100%);
            font-family: YouSheBiaoTiHei;
            font-size: 1.125rem;
            font-weight: normal;
            color: #FFFFFF;
            text-align: center;
            line-height: 2.6vh;
            position: absolute;
            right: 7.8vw;
            margin-top: 3.2vh;
            cursor: pointer;  
        }
        .markBtn {
            width: 4.5vw;
            height: 2.6vh;
            border-radius: 3px;
            background: linear-gradient(180deg, #2AC6FF 0%, #127FFF 100%);
            font-family: YouSheBiaoTiHei;
            font-size: 1.125rem;
            font-weight: normal;
            color: #FFFFFF;
            text-align: center;
            line-height: 2.6vh;
            position: absolute;
            right: 2.8vw;
            margin-top: 3.2vh;
            cursor: pointer;
        }

        .pic-box {
            display: flex;
            margin-top: 7.2vh;
            padding: 0 2.3vh;
            justify-content: center;

            .pic-word {
                .markImg {
                    width: 39.8vw;
                    height: 100%;
                    border-radius: 3px;
                    margin: 0 40px;
                }

                .imgCanvas {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 39.8vw;
                    height: 100%;
                }

                p {
                    font-family: Alibaba PuHuiTi 2.0;
                    font-size: .75rem;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-bottom: 8px;
                    margin-left: 40px;
                }
            }
        }

        .subBtn {
            width: 4.5vw;
            height: 2.6vh;
            border-radius: 3px;
            background: linear-gradient(180deg, #2AC6FF 0%, #127FFF 100%);
            font-family: YouSheBiaoTiHei;
            font-size: 1.125rem;
            font-weight: normal;
            color: #FFFFFF;
            text-align: center;
            line-height: 2.6vh;
            position: absolute;
            right: 2.8vw;
            margin-top: 1.5vh;
            cursor: pointer;
        }

        .searchForm {
            margin-top: 20px;
            margin-left: 40px;

            .searchItem {
                margin-right: 0.625rem;
                margin-bottom: 1.1vh;

                .textarea-box {
                    height: 60px !important;
                    min-height: 60px !important;

                    :deep(.el-textarea__inner) {
                        height: 60px !important;
                        min-height: 60px !important;
                        background: rgba(111, 112, 112, 0.4);
                        // border: 1px solid rgba(108, 209, 255, 0.38);
                        height: 2.6vh;
                        box-shadow: 0 0 0 1px rgba(108, 209, 255, 0.38);
                        color: #fff;
                    }
                }

                :deep(.el-form-item__label) {
                    color: #fff;
                    font-size: .875rem;
                    font-family: AlibabaPuHuiTi;
                }

                .el-input {
                    width: 40.3vw;

                    :deep(.el-input__wrapper) {
                        background: rgba(111, 112, 112, 0.4);
                        // border: 1px solid rgba(108, 209, 255, 0.38);
                        height: 2.6vh;
                        box-shadow: 0 0 0 1px rgba(108, 209, 255, 0.38);

                        .el-input__inner {
                            color: #fff;
                        }
                    }
                }

                .alarm-select {
                    color: #fff;
                    width: 10.3vw;
                    background-color: #126672;
                }
            }
        }

        .dialog-footer {
            text-align: right;
            margin-right: 50px;
        }
    }

    // :deep(.compare-dialogBox) {
    //     width: 720px;
    //     height: 640px;
    //     background: url("@/assets/images/pop-pic.png") no-repeat center;
    //     background-size: 100% 100%;
    //     padding: .625rem 1rem;
    //     // margin-left: 681px;

    //     .el-dialog__title {
    //         color: #fff;
    //         font-family: AlibabaPuHuiTi;
    //     }

    //     .searchForm {
    //         margin-top: 50px;

    //         .searchItem {
    //             margin-right: 0.625rem;
    //             margin-bottom: 3vh;

    //             .el-form-item__label {
    //                 color: #fff !important;
    //                 // font-size: .875rem;
    //                 font-family: AlibabaPuHuiTi;
    //             }

    //             .el-input {
    //                 // width: 10.3vw;

    //                 .el-input__wrapper {
    //                     background: rgba(111, 112, 112, 0.4);
    //                     // border: 1px solid rgba(108, 209, 255, 0.38);
    //                     // height: 2.6vh;
    //                     box-shadow: 0 0 0 1px rgba(108, 209, 255, 0.38);

    //                     .el-input__inner {
    //                         color: #fff;
    //                     }
    //                 }
    //             }

    //             .alarm-select {
    //                 color: #fff;
    //                 width: 10.3vw;
    //                 background-color: #126672;
    //             }
    //         }
    //     }
    // }
}
</style>